// eApp_Videos.js
const videosData = {
  'Beginner Yoga': [
    { title: "Introduction to Yoga", description: "Learn the basics of yoga practice", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Simple Sun Salutations", description: "A gentle flow to start your day", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Yoga for Flexibility", description: "Easy stretches for beginners", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Breathing Techniques", description: "Master the art of pranayama", thumbnail: "", url: "", locked: false, isNew: false },
  ],
  'Intermediate Flows': [
    { title: "Vinyasa Flow", description: "A dynamic sequence of poses", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Power Yoga", description: "Build strength and stamina", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Yin Yoga", description: "Deep stretching and relaxation", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Yoga for Core Strength", description: "Focus on your abdominal muscles", thumbnail: "", url: "", locked: false, isNew: false },
  ],
  'Advanced Practices': [
    { title: "Arm Balances Workshop", description: "Master challenging arm balances", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Inversion Practice", description: "Learn to safely invert your body", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Ashtanga Primary Series", description: "A traditional and vigorous practice", thumbnail: "", url: "", locked: false, isNew: false },
    { title: "Advanced Backbends", description: "Deepen your backbends safely", thumbnail: "", url: "", locked: false, isNew: false },
  ],
};

export default videosData;
